import { business, OS } from "./stores.js";
import { get } from "svelte/store";

function hslToHex(h, s, l) {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = n => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

function rand(min, max) {
  return min + Math.random() * (max - min);
}

export function getRandomBlue() {
  var h = rand(160, 240); //to make the hues different each time
  var s = rand(45, 65);
  var l = rand(45, 75);
  // return 'hsl(' + h + ',' + s + '%,' + l + '%)';
  return hslToHex(h, s, l) + "ee"
}

export function formatTime(millisec) {
  let seconds = Math.floor(millisec / 1000);
  let minutes = 0;
  let hours = 0;

  if (seconds > 59) {
    minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;
  }

  if (minutes > 59) {
    hours = Math.floor(minutes / 60);
    minutes -= hours * 60;
  }

  let time = "";
  if (hours) {
    time += hours.toString().padStart(2, "0") + ":";
  }

  time += minutes.toString().padStart(2, "0") + ":";
  time += seconds.toString().padStart(2, "0");

  return time;
}

export function isRtl(s) {
  return true;

  //this should move to a bool on firebase

  // if (s.length == 0) return true;
  // var ltrChars =
  //     "A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF" +
  //     "\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF",
  //   rtlChars = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC",
  //   rtlDirCheck = new RegExp("^[^" + ltrChars + "]*[" + rtlChars + "]");

  // return rtlDirCheck.test(s);
}

export function createdAt(timestamp) {
  if (!timestamp) return null;
  let [date, hour] = new Date(timestamp.seconds * 1000)
    .toLocaleString("he-GB")
    .split(",");
  date = date.replace(/\./g, "/");
  let [hours, minutes] = hour.split(":");
  return `${date} - ${hours}:${minutes}`;
}

export function waited(t1, t2) {
  if (!t1 || !t2) return;
  return formatTime(t2.seconds * 1000 - t1.seconds * 1000);
}

export function isObjectEmpty(obj) {
  var name;
  for (name in obj) {
    return false;
  }
  return true;
}

export function formatPhone(number) {
  //turn "+972551231234" to "055-1231234"
  if (!number) return "";
  number = number.substring(4);
  number = "0" + number.substring(0, 2) + "-" + number.substring(2);
  return number;
}

export function itemNameTaken(item, mode, menuDraft) {

  //checking if item name exists within the section
  return menuDraft[item.sectionIdx].items.some((i, itemIdx) => {
    if (
      mode == "edit" &&
      item.itemIdx == itemIdx
    ) return false;
    if (i.name == item.name) {
      return true;
    }
  });
}

export function formatHours(from, to) {
  let str = ''
  if (from < 10) {
    str += `0${from}:00`
  } else {
    str += `${from}:00`
  }

  str += ' - ';

  if (to < 10) {
    str += `0${to}:00`
  } else {
    str += `${to}:00`
  }

  return str;
}

export var menuItemCategories = ['קפה', 'בר', 'מטבח']

export function isBusinessOpen(business) {
  if (!business?.open) return false;
  let isOpen = false;
  if (business?.schedule) {
    let date = new Date();
    let currentHour = date.getHours();
    let currentDay = date.getDay();

    let openFrom = business.schedule[currentDay].from;
    let openTo = business.schedule[currentDay].to;
    let openToday = business.schedule[currentDay].open;

    if (openToday) {
      if (openFrom < openTo) {
        isOpen = currentHour >= openFrom && currentHour < openTo;
      } else {
        isOpen = currentHour >= openFrom || currentHour < openTo;
      }
    }
  }
  return isOpen;
}

export function gotoApp() {

  let b = get(business)

  console.log(b)

  let url =
    b ? `https://cognituspickapp.page.link/${b.code}`
      : `https://cognituspickapp.page.link/main`;

  window.open(url);
}

export function copyToClipboard(str) {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};